import { Card, CardContent } from "@/components/ui/card";
import BankAccountsDisplay from "@/components/cash/BankAccountsDisplay";
import NoBankAccountsPlaceholder from "@/components/cash/NoBankAccountsPlaceholder";
import { BankAccountSummary } from "@/types/accounts";

interface BankAccountsCardProps {
  accounts: BankAccountSummary[];
  setAccounts: React.Dispatch<React.SetStateAction<BankAccountSummary[]>>;
  onMappingChanged: () => void | Promise<void>;
  /** FIN-1021/AC14 — see BankAccountsDisplay's own doc comment. */
  waitingCountByAccountId?: Map<string, number>;
}

/**
 * The accounts-or-empty-state block shared by /bank (AccountsSection) and /cash-management —
 * extracted so the two pages' identical Card/BankAccountsDisplay/NoBankAccountsPlaceholder
 * wiring has one place to change, instead of drifting the way it started to once both needed
 * an onMappingChanged prop (FIN-90 PR4).
 */
export default function BankAccountsCard({ accounts, setAccounts, onMappingChanged, waitingCountByAccountId }: BankAccountsCardProps) {
  if (accounts.length === 0) {
    return (
      <NoBankAccountsPlaceholder onOpenConnectDialog={() => {
        const dialogButton = document.querySelector('[data-state="closed"][aria-controls="radix-:r0:"]');
        if (dialogButton) {
          (dialogButton as HTMLButtonElement).click();
        }
      }} />
    );
  }

  return (
    <Card>
      <CardContent className="pt-6">
        <BankAccountsDisplay
          accounts={accounts}
          setAccounts={setAccounts}
          onMappingChanged={onMappingChanged}
          waitingCountByAccountId={waitingCountByAccountId}
        />
      </CardContent>
    </Card>
  );
}
